<template>
  <div class="col-12 backgroundForm">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Reportes Presupuesto</h4>
            <p>Reportes Ejecucion Presupuestaria</p>        
        </div>

        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="exec-reg" data-toggle="tab" href="#rep-exec-doc" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="file-pdf" /> Documento</a>

                <a class="nav-item nav-link" id="exec-approv-gral" data-toggle="tab" href="#rep-exec-res" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="tasks" /> Dependencia </a>

                <a class="nav-item nav-link" id="exec-gral" data-toggle="tab" href="#rep-exec-gral" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="folder-open" /> Resumen Gral.</a>

                <a class="nav-item nav-link" id="exec-gral" data-toggle="tab" href="#rep-cap-part" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="folder-open" /> Capitanias x Partidas</a>

                <a class="nav-item nav-link" id="exec-gral" data-toggle="tab" href="#rep-cap-grap" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="folder-open" /> Graficos Ejecucion</a>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <!-- Registro de la solicitud de ejecucion presupuestaria -->
            <div class="tab-pane fade show active" id="rep-exec-doc" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Reporte Individual
                    </div>
                </div>
                <h6>Criterios de Busqueda</h6>
                <hr>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-2">
                        <label for="t_file">Gestión</label>
                        <select id="t_document" class="form-control" v-model="year_select_individually">
                            <option v-for="yv in year_option_report" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="t_file">Dependencia</label>
                        <select id="t_document" class="form-control" v-model="dependencie_select" @change="mClearResult">
                            <option v-for="ld in dts_dependencies" :key="ld.id" :value="ld">{{ ld.name_port }}</option>
                        </select>
                    </div>
                </div>
                <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mCallListIndividually"><font-awesome-icon icon="list"/> Listar</button>
                <br><br>
                <h6>Resultado de Busqueda</h6>
                <hr>
                <button class="btn btn-info col-12 col-md-3 offset-md-9" v-if="dts_list_individually.length > 0" @click="mPrintDocumentsList">Resumen</button>
                <div class="table-responsive-lg" v-if="dts_list_individually.length > 0" id="printDocuments">                    
                    <br><br>
                    <h1 alig="center" class="d-none d-print-block">{{ dependencie_select.name_port }}</h1>
                    <table class="table table-hover">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Detalle</th>
                                <th scope="col">Reporte</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(doc,index) in dts_list_individually" :key="doc.id_exec">
                                <th scope="col">{{ index+1 }}</th>
                                <td><b>{{ doc.type_document }} {{ doc.correlative }}/ {{ doc.year_egress}}</b><br><b>Meses:</b> {{ doc.month_egress }}<br><b>Glosa:</b> {{ doc.glosa }}<br><b>Importe:</b> {{ doc.import_gral_approv | numFormat('0,0.0') }} Bs.</td>
                                <td><button class="btn btn-success d-print-none" @click="mReportIndividually(doc)"><font-awesome-icon icon="file-pdf"/></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- fin del primer tab -->
            
            <div class="tab-pane fade show" id="rep-exec-res" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Resumen Capitania
                    </div>
                </div>
                <h6>Criterios de Busqueda</h6>
                <hr>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-2">
                        <label for="t_file">Gestión</label>
                        <select id="t_document" class="form-control" v-model="year_select_resume">
                            <option v-for="yv in year_option_report" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="t_file">Dependencia</label>
                        <select id="t_document" class="form-control" v-model="dependencie_select_resume">
                            <option v-for="ld in dts_dependencies" :key="ld.id" :value="ld">{{ ld.name_port }}</option>
                        </select>
                    </div>
                </div>
                
                <button class="btn btn-success col-12 col-md-2 offset-md-5" @click="mCallResumeCapitania"><font-awesome-icon icon="window-maximize"/> Pantalla</button>
                <br><br>
                <h6>Resultado en Pantalla</h6>
                <hr>
                <button class="btn btn-info col-12 col-md-1 offset-md-8" v-if="dts_resume_captain.length > 0" @click="mPrintResumeCaptain"><font-awesome-icon icon="print"/><br> Imprimir</button>
                <button class="btn btn-outline-primary" v-if="dts_resume_captain.length > 0" @click="mCopyToClipboard('printResumeCaptain')">
                <font-awesome-icon icon="copy" /><br>copiar 
            </button>
                <div class="table-responsive" v-if="dts_resume_captain.length > 0" id="printResumeCaptain">                    
                    <br><br>
                    <h1 alig="center" class="d-none d-print-block">{{ title_resume_captain.name }} {{ title_resume_captain.year }}</h1>
                    <table class="table table-hover">
                        <thead class="thead-dark">
                            <tr align="center">
                                <th scope="col" align="center" class="align-middle">CODIGO / MESES</th>
                                <th scope="col" align="center" class="align-middle">ENE.</th>
                                <th scope="col" align="center" class="align-middle">FEB.</th>
                                <th scope="col" align="center" class="align-middle">MAR.</th>
                                <th scope="col" align="center" class="align-middle">ABR.</th>
                                <th scope="col" align="center" class="align-middle">MAY.</th>
                                <th scope="col" align="center" class="align-middle">JUN.</th>
                                <th scope="col" align="center" class="align-middle">JUL.</th>
                                <th scope="col" align="center" class="align-middle">AGO.</th>
                                <th scope="col" align="center" class="align-middle">SEP.</th>
                                <th scope="col" align="center" class="align-middle">OCT.</th>
                                <th scope="col" align="center" class="align-middle">NOV.</th>
                                <th scope="col" align="center" class="align-middle">DIC.</th>
                                <th scope="col" align="center" class="align-middle">TOTAL.<br>Bs.</th>
                                <!-- <th scope="col" align="center">EJE.<br>Bs.</th>
                                <th scope="col" align="center">SAL.<br>Bs.</th> -->
                            </tr>
                        </thead>
                        <tbody v-html="table_resume_captain">
                        </tbody>
                        
                    </table>
                </div>
            </div>
            <!-- fin del segundo TAB -->

            <div class="tab-pane fade show" id="rep-exec-gral" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Resumen General Anual
                    </div>
                </div>
                <h6>Criterios de Busqueda</h6>
                <hr>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="t_file">Gestión</label>
                        <select id="t_document" class="form-control" v-model="year_select_gral">
                            <option v-for="yv in year_option_report" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                        </select>
                    </div>
                </div>
                <button class="btn btn-success col-12 col-md-2 offset-md-4" @click="mGetResumeGral"><font-awesome-icon icon="file-pdf"/> PDF</button>
                <button class="btn btn-success col-12 col-md-2" @click="mCallResumeGral"><font-awesome-icon icon="window-maximize"/> Pantalla</button>
                <br><br>
                <h6>Resultado en Pantalla</h6>
                <hr>
                <button class="btn btn-info col-12 col-md-3 offset-md-9" v-if="table_resume_budget.length > 0" @click="mPrintResumeGralBudget"><font-awesome-icon icon="print"/> Imprimir</button>
                <div class="table-responsive" v-if="table_resume_budget.length > 0 " id="printResumeGralBudget">                    
                    <br><br>
                    <table class="table table-hover table-sm">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" colspan="3">PRESUPUESTO {{ table_resume_budget[0].year_b }}</th>
                            </tr>
                            <tr>
                                <th scope="col">Total</th>
                                <th scope="col">Asignado</th>
                                <th scope="col">No Asignado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(tr, index) in table_resume_budget" :key="index">
                                <td>{{ tr.import_budget | numFormat('0,0.0') }}</td>
                                <td>{{ tr.assign | numFormat('0,0.0') }}</td>
                                <td>{{ (tr.import_budget - tr.assign) | numFormat('0,0.0') }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-hover">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" align="center">#</th>
                                <th scope="col" align="center">DEPENDENCIA</th>
                                <th scope="col" align="center">EJECUTADO <br>Bs.</th>
                            </tr>
                        </thead>
                        <tbody v-html="table_resume_gral">
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="tab-pane fade show" id="rep-cap-part" role="tabpanel" aria-labelledby="nav-cap-part">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Resumen de Ejecucion por Capitanias y Partidas
                    </div>
                </div>
                <h6>Criterios de Busqueda</h6>
                <hr>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="t_file">Gestión</label>
                        <select id="t_document" class="form-control" v-model="year_select_cap_par">
                            <option v-for="yv in year_option_report" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                        </select>
                    </div>
                </div>
                <button class="btn btn-success col-12 col-md-2 offset-md-5" @click="mCallPartidaCaptain"><font-awesome-icon icon="window-maximize"/> Pantalla</button>
                <div class='table table-responsive'>
                    <table class="table" v-html="table_captain_partida">
                    </table>
                </div>
            </div>

            <div class="tab-pane fade show" id="rep-cap-grap" role="tabpanel" aria-labelledby="nav-cap-grap">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Graficos Ejecucion Presupuestaria
                    </div>
                </div>
                <h6>Criterios de Busqueda</h6>
                <hr>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="t_file">Gestión</label>
                        <select id="t_document" class="form-control" v-model="year_select_cap_grap">
                            <option v-for="yv in year_option_report" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                        </select>
                    </div>
                </div>
                <button class="btn btn-success col-12 col-md-2 offset-md-5" @click="mCallPartidaGrap"><font-awesome-icon icon="window-maximize"/> Pantalla</button>
                <br>
                <transition mode="fade-in">
                <div v-if="show_graps">
                    <pie-chart :title="pie1.title" :subtitle="pie1.subtitle" :name-pies="pie1.namePie" :series-principal="pie1.seriePrincipal" v-if="renderComponent"></pie-chart>
                    <br>
                    <pie-chart :title="pie2.title" :subtitle="pie2.subtitle" :name-pies="pie2.namePie" :series-principal="pie2.seriePrincipal" v-if="renderComponent"></pie-chart>
                    <br>
                    <pie-chart :title="pie3.title" :subtitle="pie3.subtitle" :name-pies="pie3.namePie" :series-principal="pie3.seriePrincipal" v-if="renderComponent"></pie-chart>
                </div>
                </transition>
            </div>
        </div>
        <modal-loading :id-modal="id_m_progress" :title="title_m" :status-send="send_dispatch" ></modal-loading>
  
        <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
  </div>
  
</template>

<script>
import numeral from 'numeral';
import axios from 'axios';
import Vue from 'vue';
const qs=require('qs');

import pieChart from '../charts/PieChart';

import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';

export default {
    name:'budget-report',
    data(){
        return{
            modal_report:'idBudgetPrint',
            modal_rep_title:'Ejecucion Presupuestaria',
            modal_rep_content:'Impresion Documentos',
            url_report:'pdfExecBudget',
            id_reporte:0,
            show_graps:false,
            year_select_cap_grap:0,
            renderComponent:true,
            pie1:{
                title:'Torta Titulo',
                subtitle:'Subtitulo',
                seriePrincipal:[['Papel', 8]],
                namePie:'nombrePies'
            },
            pie2:{
                title:'Torta Titulo',
                subtitle:'Subtitulo',
                seriePrincipal:[['Papel', 8]],
                namePie:'nombrePies'
            },
            pie3:{
                title:'Torta Titulo',
                subtitle:'Subtitulo',
                seriePrincipal:[['Papel', 8]],
                namePie:'nombrePies'
            },
            dts_pie:{
                total:0,
                execute:0
            },
            dts_pie_captain:[],
            dts_pie_partidas:[],
            year_select_gral:null,
            table_captain_partida:null,
            table_dts_cp:[],
            year_select_cap_par:0,
            title_resume_captain:{
                name:null,
                year:0
            },
            table_resume_budget:[],
            table_resume_gral:null,
            table_resume_captain:null,
            dts_head_resume_captain:[],
            dts_resume_captain:[],
            dependencie_select_resume:{},
            year_select_resume:0,
            dts_list_individually:[],
            year_select_individually:0,
            year_option_report:[],
            dependencie_select:{},
            dts_dependencies:[],
            months:[
                {id:1, detail:'Enero'},
                {id:2, detail:'Febrero'},
                {id:3, detail:'Marzo'},
                {id:4, detail:'Abril'},
                {id:5, detail:'Mayo'},
                {id:6, detail:'Junio'},
                {id:7, detail:'Julio'},
                {id:8, detail:'Agosto'},
                {id:9, detail:'Septiembre'},
                {id:10, detail:'Octubre'},
                {id:11, detail:'Noviembre'},
                {id:12, detail:'Diciembre'},
            ],
            id_m_progress:'mrexecute',
            title_m:'Cargando',
            send_dispatch:true
        }
    },
    mounted(){
        this.mCallDependencies();
        this.mObtainYear();
    },
    methods:{
        mCopyToClipboard(elemento) {
            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada al portapapeles', 'Archivo copiado')
        },
        async mCallPartidaGrap(){
            if(this.year_select_cap_grap!==0){
                let dayCurrent=new Date();
                let months=["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
                let current=`${dayCurrent.getDate()}/${months[dayCurrent.getMonth()]}/${dayCurrent.getFullYear()}`;
                this.show_graps=false;
                let dts_pie=await axios.get(`partCapGraps/${this.year_select_cap_grap}?api_token=${Vue.auth.getToken()}`);
                
                let dts_pie_aux=dts_pie.data;
                console.log(dts_pie_aux);
                if(dts_pie_aux.captains.length > 0){
                    this.show_graps=true;
                    // pie 1
                    // Reiniciamos las series en cada pie
                    this.pie1.seriePrincipal=[];
                    this.pie2.seriePrincipal=[];
                    this.dts_pie_captain=[];

                    this.dts_pie.total=dts_pie_aux.assign[0].import_budget;
                    let aux_execute=0;

                    dts_pie_aux.captains.forEach(cap=>{
                        aux_execute+=parseFloat(cap.execute);
                    })

                    this.dts_pie.execute=aux_execute;
                    // pie 1
                    this.pie1.title="Ejecucion Presupuestaria";
                    this.pie1.subtitle=`FH: ${current}`;
                    this.pie1.namePie="Porcentaje %"
                    // ejecutado porcentajec
                    console.log(this.dts_pie.execute/this.dts_pie.total*100);
                    let percent_exec=parseFloat((this.dts_pie.execute/this.dts_pie.total*100).toFixed(2));
                    // percent_exec=percent_exec.toFixed(2);
                    // disponible porcentaje
                    let percent_disp=parseFloat((100-percent_exec).toFixed(2));

                    let serie_aux=[["EJECUTADO", percent_exec], ["NO EJECUTADO", percent_disp]];
                    this.pie1.seriePrincipal=serie_aux;
                    
                    // pie 2 x capitanias
                    let serie_captain_aux=[];
                    let sum_captains=0;
                    dts_pie_aux.captains.forEach(cap=>{
                        // obtenemos el porcentaje de ejecucion
                        let aux_percent= parseFloat((parseFloat(cap.execute)/this.dts_pie.total*100).toFixed(2));
                        serie_captain_aux=[cap.captain, aux_percent];
                        sum_captains+=aux_percent;
                        this.dts_pie_captain.push(serie_captain_aux);
                    })
                    let auxNotExecuteCaptain=parseFloat((100-sum_captains).toFixed(2));
                    this.dts_pie_captain.push(['NO EJECUTADO',auxNotExecuteCaptain]);

                    this.pie2.title="Ejecucion Presupuestaria por Capitania";
                    this.pie2.subtitle=`FH: ${current}`
                    this.pie2.namePie="Porcentaje %"
                    this.pie2.seriePrincipal=this.dts_pie_captain;
                    

                    // pie 3 por partidas
                    let serie_partidas_aux=[];
                    let sum_partidas=0;
                    dts_pie_aux.exec.forEach(execute=>{
                        // obtenemos el porcentaje de ejecucion
                        let aux_percent= parseFloat((parseFloat(execute.total_exec)/this.dts_pie.total*100).toFixed(2));
                        serie_partidas_aux=[`${execute.code}-${execute.code_description}`, aux_percent];
                        sum_partidas+=aux_percent;
                        this.dts_pie_partidas.push(serie_partidas_aux);
                    })
                    let auxNotExecutePartidas=parseFloat((100-sum_partidas).toFixed(2));
                    this.dts_pie_partidas.push(['NO EJECUTADO',auxNotExecutePartidas]);
                    
                    console.log(this.dts_pie_partidas);

                    this.pie3.title="Ejecucion Presupuestaria por Partida";
                    this.pie3.subtitle=`FH: ${current}`
                    this.pie3.namePie="Porcentaje %"
                    this.pie3.seriePrincipal=this.dts_pie_partidas;

                    this.forceRerender();
                }else{
                    toastr.info('No hay registros de la gestion');
                }     
            }else{
                toastr.warning('Seleccione una gestion', 'Gestion');
            }
        },
        async mCallPartidaCaptain(){
            // llamamos a todas las partidas y capitanias y sus respectivos gastos
            if(this.year_select_cap_par!==0){
                let dts_exec=await axios.get(`partCapExec/${this.year_select_cap_par}?api_token=${Vue.auth.getToken()}`);
                console.log(dts_exec);
                this.table_dts_cp=dts_exec.data;
                this.mGenerateCaptainPart();
            }else{
                toastr.warning('Seleccione una gestion', 'Gestion');
            }
        },
        mGenerateCaptainPart(){
            
            let codes=this.table_dts_cp.assign;
            let captain=this.table_dts_cp.captains;
            let execute=this.table_dts_cp.exec;
            let codes_totales=[];
            codes.forEach(cod=>{
                let aux_codes={
                    "codes":cod.budget_code,
                    "suma":0
                };
                codes_totales.push(aux_codes);
            });

            let aux_head=`<thead><tr>
                                <th class="align-middle">#</th>
                                <th class="align-middle">Reparticion</th>`;
            codes.forEach(cod=>{
                aux_head+=`<th class="align-middle">${cod.glosa}<br>${cod.budget_code}<br>${cod.import_budget} Bs.</th>`;
            })
            aux_head+=`<th class="align-middle">TOTAL Bs.</th>`;
            aux_head+='</tr></thead>'

            let bodyTable='<tbody>';
            let totalGral=0;
            captain.forEach((cp, index)=>{
                let totalParcial=0;
                bodyTable+=`<tr><td>${index+1}</td><td>${cp.name_port}</td>`;
                
                codes.forEach(cod_aux=>{
                    let aux_imp=0;
                    execute.forEach(exe=>{
                        if(exe.code===cod_aux.budget_code && exe.captain===cp.id_port){
                            aux_imp=exe.total_exec;                            
                        }
                    })
                    if(aux_imp>0){
                        let indCode=codes_totales.findIndex(cb=> cb.codes===cod_aux.budget_code);
                        codes_totales[indCode].suma+=parseFloat(aux_imp);

                        totalParcial+=parseFloat(aux_imp);
                        bodyTable+=`<td>${aux_imp}</td>`;
                    }else{
                        bodyTable+=`<td>--</td>`;
                    }
                })
                
                bodyTable+=`<td>${totalParcial}</td></tr>`;
                totalGral+=totalParcial;
            });
            bodyTable+=`<tr><td colspan="2"><b>Totales</b></td>`;
            codes_totales.forEach(dtsc=>{
                bodyTable+=`<td>${dtsc.suma}</td>`;
            });
            bodyTable+=`<td>${totalGral}</td></tr>`;

            this.table_captain_partida=aux_head+bodyTable;
        },
        mGetResumeGral(){
            // pdf
            if(this.year_select_gral>0){
                this.id_reporte=this.year_select_gral;
                this.url_report='pdfResumeBudgetGral';
                $('#'+this.modal_report).modal('show');
                // let url=btoa(`pdfResumeBudgetGral/${this.year_select_gral}`);
                // this.mGenerateReport(url);
            }else{
                toastr.warning('Seleccione una gestion', 'Error');
            }
        },
        async mCallResumeGral(){
            // pantalla
            if(this.year_select_gral>0){
                try {
                    this.title_m='Solicitando';
                    this.activeModal(this.id_m_progress);
                    let rbudget=await axios.get(`getResumeGralBudget/${this.year_select_gral}?api_token=${Vue.auth.getToken()}`);
                    // console.log(rbudget.data);
                    let cap=rbudget.data.captains;
                    let exec=rbudget.data.exec;
                    let assign=rbudget.data.assign;
                    this.table_resume_budget=rbudget.data.resume;    
                    this.table_resume_gral='';
                    let auxTable='';

                    let assign_gral=0;
                    let exec_gral=0;
                    let saldo_gral=0;

                    cap.forEach((item, key)=>{
                        let assi=0;
                        let ex=0;
                        let saldo=0;

                        auxTable+=`<tr>
                                    <td>${key+1}</td>
                                    <td>${item.name_port}</td>`;
                        // if(assign.length > 0){
                        //     assign.forEach((as)=>{
                        //         if(as.id_port === item.id_port){
                        //             assi=as.assign;                                
                        //         }
                        //     });
                        // }
                        
                        if(exec.length > 0){
                            exec.forEach((exaux)=>{
                                if(exaux.id_port === item.id_port){
                                    ex=exaux.exec;                                
                                }
                            });
                        }
                        // let auxsaldo=parseFloat(assi)-parseFloat(ex);
                        // assign_gral+=parseFloat(assi);
                        exec_gral+=parseFloat(ex);
                        // saldo_gral+=auxsaldo;
                        // assi=numeral(assi).format('0,0.0');
                        ex=numeral(ex).format('0,0.0');                        
                        // saldo=numeral(auxsaldo).format('0,0.0');                        
                        
                        auxTable+=`<td>${ex}</td>
                                   </tr>`;
                    });
                    // let aux_assign_gral=numeral(assign_gral).format('0,0.0');
                    let aux_exec_gral=numeral(exec_gral).format('0,0.0');
                    // let aux_saldo_gral=numeral(saldo_gral).format('0,0.0');
                    auxTable+=`<tr>
                                <td colspan="2"><b>TOTAL</b></td>
                                <td> ${aux_exec_gral}</td>
                                </tr>`
                    this.table_resume_gral=auxTable;
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                    }, 1000);
                } catch (error) {
                    toastr.error('Error al Solicitar Datos ERB-001', 'Error');
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                    });
                }       

            }else{
                toastr.warning('seleccione una gestion', 'Error');
            }
        },
        mGenerateTableResumeCaptain(){
            let monthsAux=[{"mes":1, "suma":0},{"mes":2, "suma":0},{"mes":3, "suma":0},{"mes":4, "suma":0},{"mes":5, "suma":0},{"mes":6, "suma":0},{"mes":7, "suma":0},{"mes":8, "suma":0},{"mes":9, "suma":0},{"mes":10, "suma":0},{"mes":11, "suma":0},{"mes":12, "suma":0}];
            this.table_resume_captain=null;
            let tableAux='';
            this.dts_head_resume_captain.forEach((item, index)=>{
                tableAux+=`<tr><td scope="col" class="align-middle">${item.budget_code}<br>${item.glosa}</td>`;
                let ctrl_reg=0;
                console.log(this.dts_resume_captain);
                this.dts_resume_captain.forEach((mr)=>{
                    
                    if(mr.budget_code===item.budget_code){
                        ctrl_reg=1;
                        let total_year=0;
                        for(let i=1 ; i<=12; i++){
                            
                            let quantity=0;
                            let year_egress=0;
                            let textAux='';
                            // contador de meses
                            let contador_month=mr.months.length;
                            
                            mr.months.forEach((mItem)=>{
                                
                                if(mItem.month === i){
                                    let mto=monthsAux.findIndex( mb => mb.mes === mItem.month);
                                    monthsAux[mto].suma += parseFloat(mItem.quantity);
                                    quantity= mItem.quantity ;
                                    year_egress=mItem.year_egress;
                                    textAux+=`${(quantity).toFixed(2)} <b>(${year_egress})</b><br>`;
                                    total_year+=parseFloat(quantity);
                                }
                            })
                            if(quantity>0 && textAux!==''){
                                tableAux+=`<td align="center" class="align-middle">${textAux}</td>`;
                            }else{
                                tableAux+=`<td align="center" class="align-middle">---</td>`;
                            }
                        }
                        tableAux+=`<td align="center" class="align-middle"><b>${total_year}</b></td>`;
                    }
                })
                console.log(monthsAux);
                if(ctrl_reg===0){
                    for(let i=1 ; i<=13; i++){                                                    
                        tableAux+=`<td align="center" class="align-middle">---</td>`;
                    }
                }

                // let import_b=numeral(item.import_budget).format('0,0.0');                        
                // let execute=numeral(item.sum).format('0,0.0');
                // let saldo=(item.import_budget - item.sum);
                // saldo=numeral(saldo).format('0,0.0');
                // tableAux+=`<td>${import_b}</td>`;
                // tableAux+=`<td>${execute}</td>`;
                // tableAux+=`<td>${saldo}</td>`;
                tableAux+=`</tr>`;                
            })
            let resultsEnd=`<tr><td><b>Totales</b></td>`;
            let auxResultFinal=0;
            monthsAux.forEach( mdts =>{
                    auxResultFinal+=mdts.suma;
                    resultsEnd+=`<td align="center" class="align-middle">${(mdts.suma).toFixed(2)}</td>`;
            });
            resultsEnd+=`<td align="center" class="align-middle">${(auxResultFinal).toFixed(2)}</td>`;
            resultsEnd+=`</tr>`;
            this.table_resume_captain=tableAux+resultsEnd;
            // console.log(this.table_resume_captain);
        },
        async mCallResumeCapitania(){

            if(this.dependencie_select_resume.id > 0 && this.year_select_resume>0 ){
                
                this.title_m='Solicitando';
                this.activeModal(this.id_m_progress);

                this.title_resume_captain.name=this.dependencie_select_resume.name_port;
                this.title_resume_captain.year=this.year_select_resume;
                this.table_resume_captain=null
                this.dts_head_resume_captain=[];
                this.dts_resume_captain=[];
                try {
                // aqui formateamos la matriz en pantalla
                let rc=await axios.get(`getResumeBudget/${this.dependencie_select_resume.id}/${this.year_select_resume}?api_token=${Vue.auth.getToken()}`);
                // console.log(rc);
                if(rc.data.detail.length > 0){
                    this.dts_head_resume_captain=rc.data.total_exec;
                    let auxList={}
                    let auxDetail=rc.data.detail;
                    let contId=[];

                    // aqui realizamos la verificacion de las veces que aparece un id para su division inclusive su codigo
                    auxDetail.forEach((item, index)=>{
                        if(index===0){
                            let auxCont={"idConta":item.id_egress_master, "num":1, "budget_code":item.budget_code};
                            contId.push(auxCont);
                        }else{
                            let indB=contId.findIndex(ib=> (ib.idConta === item.id_egress_master && ib.budget_code === item.budget_code) );
                            if(indB>=0){
                                contId[indB].num++;
                            }else{
                                let auxCont={"idConta":item.id_egress_master, "num":1, "budget_code":item.budget_code};
                                contId.push(auxCont);
                            }
                        }
                    });
                    
                    console.log(contId);

                    auxDetail.forEach((item)=>{
                        let idBus=contId.findIndex(fib => fib.idConta === item.id_egress_master );
                        let newDivisor=contId[idBus].num;
                        // console.log(`el nuevo divisor es ${newDivisor}`);
                        if(this.dts_resume_captain.length>0){
                            auxList={};
                            let pindex=-1;
                            let idSearch;
                            this.dts_resume_captain.forEach((dl, index)=>{
                                idSearch=dl.id_egress_master.includes(item.id_egress_master);
                                console.log(`${idSearch} en el indice ${index}`);
                                if(item.budget_code === dl.budget_code && item.id_assign_budget === dl.id_assign_budget){
                                    pindex=index;        
                                }
                            })
                            // si econtro codigos iguales y ademas el id master es igual verdad
                            if(pindex>-1 && idSearch){
                                // si se encuentra el indice y el id master solo se agrega el mes verificando si existe el mes y sumandolo ademas del mes
                                let cMonth=0;
                                this.dts_resume_captain[pindex].months.forEach((m)=>{
                                    console.log(`el mes es ${m.month} del item es ${item.month_egress}`);
                                    console.log(`el anio es ${m.year_egress} del item es ${item.year_egress}`);
                                    if(m.month === item.month_egress && m.year_egress === item.year_egress){
                                        // aqui aumentamos la linea de division para dividir el importe en los meses que aparece
                                        // console.log(newDivisor);
                                        m.quantity+=parseFloat(item.sum)/newDivisor;
                                        // Sumar el importe del egreso
                                        cMonth++;
                                    }
                                })
                                if(cMonth===0){
                                    // si es igual a cero siginifica que no encontro el mes agregar uno nuevo
                                    console.log(`el mes del item es ${item.month_egress}`);
                                    console.log(`el anio del item es ${item.year_egress}`);
                                    console.log(`el id del item es ${item.id_egress_master}`);
                                    // console.log(this.idCont);
                                    

                                    let monthAux={
                                        month:item.month_egress,
                                        quantity:parseFloat(item.sum)/newDivisor,
                                        year_egress:item.year_egress
                                    }
                                    this.dts_resume_captain[pindex].months.push(monthAux);
                                }//por else ya no hacer nada ya ingreso y sumo en bucle
                                
                            }else if(pindex > -1){
                                // aca no encontro el id master pero si igual al codigo de asignacion sumar el importe
                                this.dts_resume_captain[pindex].id_egress_master.push(item.id_egress_master);
                                let cMonth=0;
                                this.dts_resume_captain[pindex].months.forEach((m)=>{
                                    if(m.month === item.month_egress && m.year_egress === item.year_egress){
                                        // let idBus=idCont.findIndex(fib => fib.idCont === item.id_egress_master );
                                        // let newImp=parseFloat(item.sum)/idCont[idBus].num;
                                        m.quantity+=parseFloat(item.sum)/newDivisor;
                                        cMonth++;
                                    }
                                    // TODO: aqui inlcuir algun codigo de control por lo de otra gestion
                                })
                                if(cMonth===0){
                                    // si es igual a cero siginifica que no encontro el mes agregar uno nuevo
                                    // let idBus=idCont.findIndex(fib => fib.idCont === item.id_egress_master );
                                    // let newImp=parseFloat(item.sum)/idCont[idBus].num;
                                    let monthAux={
                                        month:item.month_egress,
                                        quantity:parseFloat(item.sum)/newDivisor,
                                        year_egress:item.year_egress
                                    }
                                    
                                    this.dts_resume_captain[pindex].months.push(monthAux);
                                }//por else ya no hacer nada ya ingreso y sumo en bucle
                                // console.log(this.dts_resume_captain[pindex].total);
                                this.dts_resume_captain[pindex].total+=parseFloat(item.sum)
                            }else{
                                // no encontro ni lo uno ni lo otro añadir nuevo registro
                                // let idBus=idCont.findIndex(fib => fib.idCont === item.id_egress_master );
                                // let newImp=parseFloat(item.sum)/idCont[idBus].num;
                                auxList={
                                    id_egress_master:[item.id_egress_master],
                                    id_assign_budget:item.id_assign_budget,
                                    budget_code:item.budget_code,
                                    detalle:item.glosa,
                                    months:[{
                                        month:item.month_egress,
                                        quantity:parseFloat(item.sum)/newDivisor,
                                        year_egress:item.year_egress
                                    }],
                                    total:parseFloat(item.sum)
                                }
                                this.dts_resume_captain.push(auxList);
                            }

                        }else{
                            // let idBus=idCont.findIndex(fib => fib.idCont === item.id_egress_master );
                            // let newImp=parseFloat(item.sum)/idCont[idBus].num;                        
                            auxList={
                                id_egress_master:[item.id_egress_master],
                                id_assign_budget:item.id_assign_budget,
                                budget_code:item.budget_code,
                                detalle:item.glosa,
                                months:[{
                                    month:item.month_egress,
                                    quantity:parseFloat(item.sum)/newDivisor,
                                    year_egress:item.year_egress
                                }],
                                total:parseFloat(item.sum)
                            }
                            this.dts_resume_captain.push(auxList);

                        }
                    });
                    // console.log(this.dts_resume_captain);
                    this.mGenerateTableResumeCaptain();
                }else{
                    toastr.warning('No existen registros de Ejecucion');
                    
                }
                setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                        this.title_m='Cargando';
                    }, 500)
                } catch (error) {
                    toastr.error('CODE RCP-01', 'Error');
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                        this.title_m='Cargando';
                    }, 500)
                }
            }else{
                toastr.warning('verifique que los campos de busqueda esten completos', 'Error');
            }
        },
        mGetResumeCapitania(){
            // aca solicitamos el impreso en PDF de la capitania
            if(this.dependencie_select_resume.id > 0 && this.year_select_resume>0 ){
                let url=btoa(`pdfResumeCaptain/${this.dependencie_select_resume.id}/${this.year_select_resume}`);
                this.mGenerateReport(url);
            }else{
                toastr.warning('Verifique que las opciones esten seleccionadas', 'Error');
            }
        },
        mClearResult(){
            this.dts_list_individually=[];
        },
        mPrintDocumentsList(){
            this.$htmlToPaper('printDocuments');
        },
        mPrintResumeCaptain(){
            this.$htmlToPaper('printResumeCaptain');
        },
        mPrintResumeGralBudget(){
            this.$htmlToPaper('printResumeGralBudget');
        },
        mReportIndividually(d){
            
            this.id_reporte=d.id_exec;
            $('#'+this.modal_report).modal('show');

            // let url=btoa(`pdfExecBudget/${d.id_exec}`);
            // // console.log(d.id_exec);
            // this.mGenerateReport(url);
        },
        mGenerateReport(url){
            // this.activeModal(this.id_m_progress);
            // let url_report=btoa(`pdfEnrollmentShip/${idb}/${cod}`);
            let route = this.$router.resolve({path: `/report/${url}`});
            
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');

            // axios.get(url,
            //     // axios.get(`pdfReportPending/${auxPort}/${this.optionSearch}/${this.date_init}/${this.date_end}`,
            //     {
            //         responseType:'blob'
            //     })
            //     .then(res => {
            //             // console.log(res)
            //         // const url = window.URL.createObjectURL(new Blob([res.data]));
            //         const url = window.URL.createObjectURL(new Blob([res.data]));
            //         const link = document.createElement('a');
            //         link.href = url;
            //         link.setAttribute('download', 'CargosPendientes.pdf');
            //         document.body.appendChild(link);
            //         link.click();
            //         this.inactiveModal(this.id_m_progress);
            //     })
            //     .catch(error => {
            //         console.log(error);
            //         this.inactiveModal(this.id_m_progress);
            //     })
        },
        async mCallListIndividually(){
            if(this.dependencie_select.id !== null && this.year_select_individually > 0){
                this.title_m='Solicitando';
                this.activeModal(this.id_m_progress);
                try {
                    this.dts_list_individually=[];
                    let lr=await axios.get(`getAllDocumentsBudget/${this.dependencie_select.id}/${this.year_select_individually}?api_token=${Vue.auth.getToken()}`);
                    
                    if(lr.data.length > 0){
                        let dts=lr.data;
                        
                        let auxArray;
                        let auxPosition={
                            id:0,
                            index:0
                        };
                        // debemos formatear los datos
                        dts.forEach((dt, index) => {
                            
                            if(auxPosition.id === dt.id_exec){
                                let monthTemp=this.months[dt.month_egress-1].detail;
                                // let month=dt[auxPosition.index].month_egress+' '+dt.month_egress;
                                this.dts_list_individually.forEach((item, index)=>{
                                    if(auxPosition.id === item.id_exec){
                                        item.month_egress=item.month_egress+' '+monthTemp;
                                    }
                                })
                                auxPosition.id=dt.id_exec;
                                auxPosition.index=index;
                            }else{
                                auxPosition.id=dt.id_exec;
                                auxPosition.index=index;
                                let monthTemp=this.months[dt.month_egress-1].detail;
                                let auxList={
                                    id_exec:dt.id_exec,
                                    correlative:dt.correlative,
                                    year_egress:dt.year_egress,
                                    month_egress:monthTemp,
                                    type_document:dt.type_document,
                                    glosa:dt.glosa,
                                    import_gral_approv:dt.import_gral_approv
                                }
                                this.dts_list_individually.push(auxList)
                            }                            
                        });
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        },600)
                        // console.log(this.dts_list_individually);
                    }else{
                        toastr.info('No se encontraron resultados', 'Advertencia');
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        },600)
                    }
                } catch (error) {
                    toastr.error('Error CLR-2', 'Error');
                    setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                    },600)
                }
            }else{
                toastr.warning('Verifique que ambas opciones esten seleccionadas', 'Advertencia');
            }
        },
        async mCallDependencies(){
            // let dr=await axios.get(`getAllDependecies`);
            // let tf=await axios.get(`globals/file`);
            let dr=await axios.get(`getAllDependecies?api_token=${Vue.auth.getToken()}`);
            let tf=await axios.get(`globals/file?api_token=${Vue.auth.getToken()}`);
            this.type_files=tf.data;
            this.dts_dependencies=dr.data;
        },
        mObtainYear(){
            this.year_option_report=[];
            let anio=new Date();
            let current_year=anio.getFullYear();
            let old_year=anio.getFullYear()-10;
            for(let i = old_year ; i<=current_year ;i++){
                let auxYear={
                    id:i,
                    anio:i
                }
                this.year_option_report.push(auxYear);
            }
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        },
        forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            // If you like promises better you can
            // also use nextTick this way
            this.$nextTick().then(() => {
                // Add the component back in
                this.renderComponent = true;
            });
        }
    },
    computed:{

    },
    components:{
        'modal-loading':modalLoading,
        'pie-chart':pieChart,
        'modal-report':modalReport
    
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/finanzas/BudgetReport.vue